import {Component, ElementRef, Inject, Injector, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from "@angular/common";

import {
  APPLY_STYLES_TYPE,
  DISPLAY_TYPE,
  IWidgetConfig,
  provideAsWidgetRef,
  register,
  StylableComponent,
  styler
} from "@wm/components-base";
import {AccordionDirective} from "../accordion.directive";
import {WmsTranscludeDirective} from "../../../page/wms-transclude/wms-transclude.directive";
import {get} from "lodash-es";

const DEFAULT_CLS = 'app-accordion-panel panel';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-accordionpane',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: 'div[wmAccordionpane]',
  template: `
    <div class="panel-heading clearfix" (click)="toggle($event)" [ngClass]="{active: isActive}">
      <h3 class="panel-title">
        <a href="javascript:void(0);" role="button" class="accordion-toggle" [attr.aria-label]="title" [attr.aria-expanded]="isActive" [attr.aria-controls]="name">
          <div class="pull-left">
            <i class="app-icon panel-icon {{iconclass}}" [hidden]="!iconclass"></i>
          </div>
          <div class="pull-left">
            <div class="heading" [innerHTML]="title"></div>
            <div class="description" [innerHTML]="subheading"></div>
          </div>
        </a>
      </h3>
      <div class="panel-actions">
        <span class="app-label badge label-{{badgetype}}">{{badgevalue}}</span>
        <button type="button" aria-label="Collapse/Expand" [attr.aria-expanded]="isActive" [attr.aria-controls]="name"
                class="app-icon panel-action wi"
                title="{{appLocale.LABEL_COLLAPSE}}/{{appLocale.LABEL_EXPAND}}">
          <i [ngClass]="isActive ? 'wi wi-minus' : 'wi wi-plus'"></i>
        </button>
      </div>
    </div>
    <div class="panel-collapse collapse" role="tabpanel" aria-labelledby="panel description" [ngClass]="isActive ? 'collapse in' : 'collapse'">
      <div class="panel-body" wmsTransclude page-container-target>
        <ng-content></ng-content>
      </div>
    </div>
  `,
  providers: [
    provideAsWidgetRef(AccordionpaneComponent)
  ],
  exportAs: 'wmAccordionpane',
  standalone: true,
  imports: [CommonModule, WmsTranscludeDirective],
  styles: []
})
export class AccordionpaneComponent extends StylableComponent {
  static initializeProps = register('wm-accordionpane');

  public isActive = false;
  public iconclass: string;
  public title: any;
  public subheading: string;
  public badgetype: any;
  public badgevalue: string;
  public smoothscroll: any;
  private isdynamic: boolean;

  public name: string;

  constructor(inj: Injector, @SkipSelf() @Optional() private _viewParent: AccordionDirective,
              @SkipSelf() @Inject(ElementRef) public _el: any) {
    super(inj, WIDGET_CONFIG, _viewParent);
    styler(this.nativeElement, this, APPLY_STYLES_TYPE.SHELL);
  }

  toggle(evt: Event) {
    if (this.isActive) {
      this.collapse(evt);
    } else {
      this.expand(evt);
    }
  }

  collapse(evt?: Event) {
    if (!this.isActive) {
      return;
    }
    this.isActive = false;
    this.notifyParent(false, evt);
  }

  expand(evt?: Event) {
    if (this.isActive) {
      return;
    }
    this.isActive = true;
    this.notifyParent(true, evt);
  }

  notifyParent(isExpand: boolean, evt?: Event) {
    this.getParentScope().notifyChange(this, isExpand, evt);
  }

  private getParentScope(): AccordionDirective {
    return this._viewParent || this._el.nativeElement.widget || get($(this.nativeElement).closest('[widgettype="wm-accordion"]')[0], 'widget');
  }
  override ngAfterViewInit() {
    super.ngAfterViewInit();
    styler(
      this.nativeElement.querySelector('.panel-body') as HTMLElement,
      this,
      APPLY_STYLES_TYPE.INNER_SHELL
    );
    this.getParentScope().addPane(this);
  }
}

